var SiteReportingController = (function () {
    function SiteReportingController(env, $filter, DTS, DTOptionsBuilder, DTColumnBuilder, $stateParams, $state, socket, $scope, $compile, settings) {
        var _this = this;
        this.env = env;
        this.$filter = $filter;
        this.DTS = DTS;
        this.DTOptionsBuilder = DTOptionsBuilder;
        this.DTColumnBuilder = DTColumnBuilder;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.$compile = $compile;
        this.settings = settings;
        this.reportIsBuilt = false;
        this.pivotIsBuilt = false;
        this.visible = false;
        this.visiblePivot = false;
        this.socket.forward('reporting', this.$scope);
        this.$scope.$on('socket:reporting', function (event, data) {
            _this.results = data;
            console.log('General Report', _this.results);
            _this.reportIsBuilt = true;
        });
        this.socket.forward('pivot.reporting', this.$scope);
        this.$scope.$on('socket:pivot.reporting', function (event, data) {
            _this.data1 = data;
            _this.pivotIsBuilt = true;
        });
        this.socket.forward('report.generalCreated', this.$scope);
        this.$scope.$on('socket:report.generalCreated', function (event, data) {
            if (!data.payload.error) {
                var a = document.createElement('A');
                document.body.appendChild(a);
                a.setAttribute('style', 'display: none;');
                var url = window.URL.createObjectURL(new Blob([data.payload], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                }));
                a.setAttribute('href', url);
                var d = new Date().toDateString();
                a.setAttribute('download', "DMT-General-Report_" + d + ".xlsx");
                a.click();
            }
        });
    }
    SiteReportingController.prototype.toggle = function () {
        this.visible = !this.visible;
        if (this.visible && !this.results && this.settings.up.swdr_permissions.general_report) {
            console.log('Fetching General Report...');
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'getReportingData',
                    script: '/reporting/reporting',
                    user: this.env.user.email,
                    token: this.env.user.token
                }
            });
        }
    };
    SiteReportingController.prototype.togglePivot = function () {
        this.visiblePivot = !this.visiblePivot;
        if (this.visiblePivot && !this.data1 && this.settings.up.swdr_permissions.pivot_report) {
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'getPivotData',
                    script: '/reporting/reporting',
                    user: this.env.user.email,
                    token: this.env.user.token
                }
            });
        }
    };
    SiteReportingController.prototype.$onInit = function () {
        //maybe just use the imts provided by server...
        this.imtHeaders = [
            '',
            'A/NZ IMT',
            'ASEAN IMT',
            'Asia Pacific IOT',
            'BeNeLux IMT',
            'Brazil IMT',
            'CEE IMT',
            'Canada IMT',
            'Central East Africa',
            'DACH IMT',
            'Egypt IMT',
            'Europe IOT',
            'France IMT',
            'GCG IMT',
            'Greater China Group IOT',
            'Gulf & Levante',
            'I/SA IMT',
            'Italy IMT',
            'Japan IMT',
            'Korea IMT',
            'Latin America IOT',
            'MEA IMT',
            'Mexico IMT',
            'Middle East & Africa IOT',
            'Nordic IMT',
            'North America IOT',
            'North West Africa',
            'SPGI IMT',
            'SSA IMT',
            'South Africa',
            'UKI IMT',
            'US IMT'];
        this.testRows = ['SUBSTATDESC'];
        this.testCols = ['IMT', 'SUBSTATDESC'];
        this.testAggregatorName = 'Count';
        this.testVals = ['SUBSTATDESC'];
        this.testRendererName = 'Table';
    };
    SiteReportingController.prototype.downloadReport = function (data) {
        var exportData = [];
        for (var p in data) {
            if (data.hasOwnProperty(p)) {
                var item = void 0;
                item = {};
                item = data[p][1];
                item._stat = data[p][0];
                exportData.push(item);
            }
        }
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'downloadGeneralReport',
                script: '/reporting/report-general-excel',
                data: exportData,
                token: this.env.user.token
            }
        });
    };
    SiteReportingController.prototype.checkPivot = function (att) {
        console.info('att', this.$scope);
        console.info('this.testAggregatorName => ', this.testAggregatorName);
    };
    SiteReportingController.$inject = ['env', '$filter', 'DTS', 'DTOptionsBuilder',
        'DTColumnBuilder', '$stateParams', '$state', 'socket', '$scope', '$compile', 'settings'];
    return SiteReportingController;
}());
var SiteReportingComponent = (function () {
    function SiteReportingComponent() {
        this.templateUrl = 'reporting.html';
        this.controllerAs = 'vm';
        this.controller = SiteReportingController;
    }
    return SiteReportingComponent;
}());
angular
    .module('application')
    .component('reportingSection', new SiteReportingComponent());

//# sourceMappingURL=reporting.component.js.map
